var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"section-bg"},[_c('div',{staticClass:"header-title"},[_c('div',{staticClass:"logo-image"},[_c('img',{attrs:{"src":"/images/logo-mark.svg","alt":"ロゴ"}})]),_vm._v(" "),_c('h1',[_vm._v("\n            急性期ケア専門士"),_c('br'),_vm._v("\n            認定登録申し込み確認\n        ")])])])
}]

export { render, staticRenderFns }